import { ChangeDetectionStrategy, Component, inject, input, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { CookieConsentService } from '../../services/cookie-consent.service';

@Component({
  selector: 'aura-cookie-consent',
  imports: [MatButtonModule, MatIconModule, RouterLink],
  templateUrl: './cookie-consent.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CookieConsentComponent {
  readonly cookieService = inject(CookieConsentService);

  /** Link to privacy policy page */
  readonly privacyPolicyUrl = input<string>('/privacy-policy');

  /** Temporary choice states for customize modal */
  readonly tempAnalytics = signal<boolean>(false);
  readonly tempMarketing = signal<boolean>(false);

  constructor() {
    // Synchronize initial temporary state with stored preferences
    const current = this.cookieService.preferences();
    this.tempAnalytics.set(current.analytics);
    this.tempMarketing.set(current.marketing);
  }

  onOpenCustomize(): void {
    const current = this.cookieService.preferences();
    this.tempAnalytics.set(current.analytics);
    this.tempMarketing.set(current.marketing);
    this.cookieService.openPreferences();
  }

  onToggleAnalytics(): void {
    this.tempAnalytics.update((val) => !val);
  }

  onToggleMarketing(): void {
    this.tempMarketing.update((val) => !val);
  }

  onSaveCustomChoices(): void {
    this.cookieService.savePreferences({
      essential: true,
      analytics: this.tempAnalytics(),
      marketing: this.tempMarketing(),
    });
  }
}
